import { frontendURL } from '../../../helper/URLHelper';
import AttributionIndex from './pages/AttributionIndex.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/attribution'),
    name: 'attribution_index',
    component: AttributionIndex,
    meta: {
      permissions: ['administrator'],
    },
  },
];

export default { routes };
